import React from 'react'

export function EmptyData(props) {
    return (
        <div className="text-center text-muted">
            <h1>{props.children}</h1>
        </div>
    )
}
